import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Publication } from '../../interfaces/publication';
import { Subscription } from 'rxjs';
import { BbTableService, TableRow } from '../../services/bb-table.service';
import { UploadService } from '../../services/upload.service';
import { DateRange } from 'app/interfaces/dateRange';

@Component({
	selector: 'dashboard-ads',
	templateUrl: './dashboard-ads.component.html',
	styleUrls: ['./dashboard-ads.component.scss']
})

export class DashboardAdsComponent implements OnInit {
	rows: TableRow[] = null;

	subscriptions: Subscription = new Subscription();
	publicationLabel: Publication;
	statsDate: DateRange;
	startDate: Date;
	endDate: Date;

	protected rowDoubleClickedSubscription: Subscription;

	constructor(
		protected route: ActivatedRoute,
		private router: Router,
		protected bbTableService: BbTableService,
		protected uploadService: UploadService,) {
		this.startDate = new Date();
		this.startDate.setHours(0, 0, 0, 0);
		this.endDate = new Date();
		this.endDate.setHours(23, 59, 59, 999);
	}

	ngOnInit() {
		this.bbTableService
			.useOverlayLoading(false)
			.sort('createddate', 'desc')
			.setLimit(8)
			.setEntity('adunit')
			.setLiveUpdates(true);

		this.subscriptions.add(this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => this.rows = rows));
		this.uploadService.completedObservable.subscribe(() => this.bbTableService.getRows(true));
		this.rowDoubleClickedSubscription = this.bbTableService.rowDoubleClickedObservable.subscribe((row: TableRow) => {
			this.redirectToDetails(row);
		});
		this.bbTableService.getRows();

		this.statsDate = {
			startDate: this.startDate,
			endDate: this.endDate
		};
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['adservices/adunits', row.data.id, 'general']);
		}
	}
}
